import {useReducer, useEffect, useRef, useCallback} from 'react';

let skipOnce = true; // Don't want to potentially run the callback on initial render (it will happen)

const useReducerWithCallback = (reducer, initialState) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const callbackRef = useRef();

    const dispatchWithCallback = useCallback(
        (action, callback) => {
            callbackRef.current = callback;
            dispatch(action);
        },
        [dispatch]
    );

    useEffect(() => {
        if (skipOnce) {
            skipOnce = false;
            return;
        }
        if (callbackRef.current) {
            callbackRef.current(state);
            callbackRef.current = null;
        }
    }, [state]);

    return [state, dispatchWithCallback];
};

export default useReducerWithCallback;
